import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilsClassificationService } from 'src/app/classification/utils.service';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { DiscriminatorModel } from 'src/app/shared/services/models/risk-classification/discriminator.model';
import { DeviceTypeSectorResponse } from 'src/app/shared/services/responses/risk-classification/device-type-sector.response';

@Component({
    selector: 'app-numeric-modal',
    templateUrl: './numeric-modal.component.html',
    styleUrls: ['./numeric-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NumericModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<NumericModalComponent>,
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService, private utilService: UtilsClassificationService) { }

  public model: UntypedFormGroup;
  public discriminator: DiscriminatorModel;
  public autisticChecked: boolean = false;
  public setUppercaseText: boolean = false;

  ngOnInit(): void {
    let deviceTypeSectorResponse: DeviceTypeSectorResponse = this.utilService.getDevicetypeBySector()
    if (deviceTypeSectorResponse && deviceTypeSectorResponse.deviceTypeSector) {
      if (deviceTypeSectorResponse.deviceTypeSector.setUppercaseText)
        this.setUppercaseText = deviceTypeSectorResponse.deviceTypeSector.setUppercaseText;
    }

    this.discriminator = this.data.discriminator;
   
    this.model = this.formBuilder.group({
      value: [this.data.discriminator.value, Validators.required],
      discriminatorSelectionMotive: [],
      priorityAutistic: [false]
    });
  }

  changePriorityAutistic(event: any) {
    this.model.get('value').setValue(null);
    this.autisticChecked = event.checked
    if (event.checked) {
      this.model.get('discriminatorSelectionMotive').setValidators([Validators.required]);
      this.model.get('value').disable();
    } else {
      this.model.get('discriminatorSelectionMotive').setValidators(Validators.nullValidator);
      this.model.get('value').enable();
    }
    this.model.get('discriminatorSelectionMotive').updateValueAndValidity();
  }

  close() {
    this.matDialogRef.close();
  }

  submit() {
    if (this.model.invalid) {
      if (this.model.get('priorityAutistic').value) {
        this.alertService.show('Erro', "Preencha o motivo!", AlertType.error);
      } else {
        this.alertService.show('Erro', "Preencha o campo!", AlertType.error);
      }
      return;
    }

    if (this.model.get('priorityAutistic').value) {
      this.matDialogRef.close({ value: null, select: true, motive: this.model.get('discriminatorSelectionMotive').value });
    } else {
      let value = this.model.get("value").value
      let select = this.utilService.verifySelectGeneric(this.discriminator.minValueAllowed, this.discriminator.maxValueAllowed, value);
      this.matDialogRef.close({ value, select });
    }
  }
}

